import React from 'react';
import '../../pages/home.css';

const TalkCard = (props) => {
  return (
    <div className="talk-card">
      <div className="talk-card__img-wrap">
        <img src={props.image} alt={`Design talk by ${props.speaker}`} className="card-imgg" />
        <span className="card-tag">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <circle cx="6" cy="6" r="5" stroke="var(--color-cream)" strokeWidth="1.2" />
            <path d="M6 3.5V6L7.5 7.5" stroke="var(--color-cream)" strokeWidth="1.2" strokeLinecap="round" />
          </svg>
          {props.time}
        </span>
      </div>
      <div className="talk-card__info">
        <div className="talk-card__speaker">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <circle cx="6" cy="4.5" r="2.5" stroke="var(--color-cream)" strokeWidth="1.1" />
            <path d="M1 11c0-2.761 2.239-4 5-4s5 1.239 5 4" stroke="var(--color-cream)" strokeWidth="1.1" strokeLinecap="round" />
          </svg>
          <span className="desginer-name">{props.speaker}</span>
        </div>
        <p className="desginer-text">{props.title}</p>
      </div>
    </div>
  );
};

export default TalkCard;